export default "__VITE_ASSET__JP7nTu2f__"